/**
 * Deterministic JSON: object keys sorted recursively, `undefined` members dropped.
 * Used as the identity key for /info request de-dup and WS subscription ref-counting, so
 * `{coin:'#10', type:'l2Book'}` and `{type:'l2Book', coin:'#10'}` share one entry.
 */
export function canonicalJson(value: unknown): string {
  return JSON.stringify(sortDeep(value));
}

function sortDeep(v: unknown): unknown {
  if (Array.isArray(v)) return v.map(sortDeep);
  if (v !== null && typeof v === 'object') {
    const out: Record<string, unknown> = {};
    for (const k of Object.keys(v as Record<string, unknown>).sort()) {
      const child = (v as Record<string, unknown>)[k];
      if (child !== undefined) out[k] = sortDeep(child);
    }
    return out;
  }
  return v;
}
